import { POLICY_VERSION } from '../data/legalLinks';

export const COOKIE_CONSENT_STORAGE_KEY = 'cookie_consent_v1';

/** @typedef {{ analytics: boolean, timestamp: string, policyVersion: string }} CookieConsentState */

/** @returns {CookieConsentState | null} */
export function readCookieConsent() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed?.analytics !== 'boolean') return null;
    return parsed;
  } catch {
    return null;
  }
}

/** @param {boolean} analytics */
export function saveCookieConsent(analytics) {
  if (typeof window === 'undefined') return;
  const state = {
    analytics,
    timestamp: new Date().toISOString(),
    policyVersion: POLICY_VERSION,
  };
  localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(state));
  window.dispatchEvent(new CustomEvent('cookie-consent-changed', { detail: state }));
  return state;
}

export function hasAnalyticsConsent() {
  return readCookieConsent()?.analytics === true;
}

export function hasConsentChoice() {
  return readCookieConsent() !== null;
}
